import { ReactElement, Suspense } from 'react';
import { Spin } from 'antd';
import { Layout } from '../../../components/layout/Layout';
import Header from '../../../components/header/Header';
import Content from './Content';

const UserPage = (): ReactElement => {
  return (
    <Layout
      header={<Header />}
      content={
        <Suspense fallback={<Spin />}>
          <Content />
        </Suspense>
      }
    />
  );
};

export default UserPage;
